import { render, staticRenderFns } from "./TestType.vue?vue&type=template&id=3a8a5045&scoped=true"
import script from "./TestType.vue?vue&type=script&lang=js"
export * from "./TestType.vue?vue&type=script&lang=js"
import style0 from "./TestType.vue?vue&type=style&index=0&id=3a8a5045&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8a5045",
  null
  
)

export default component.exports